import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import categoryApi from "../api/categoryApi";

// Async thunk for fetching category
export const fetchAllCategories = createAsyncThunk("category/fetchCategory", async (_, thunkAPI) => {
  try {
    const res = await categoryApi.getAll();

    return res?.data.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.message);
  }
});

export const getCategoryById = createAsyncThunk("category/categoryById", async (id, thunkAPI) => {
  try {
    const res = await categoryApi.getById(id);

    return res?.data.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.message);
  }
});

export const createCategory = createAsyncThunk("category/createCategory", async (categoryData, thunkAPI) => {
  try {
    const res = await categoryApi.create(categoryData);

    return res?.data.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.message);
  }
});

export const deleteCategory = createAsyncThunk("category/deleteCategory", async (id, thunkAPI) => {
  try {
    const res = await categoryApi.delete(id);

    return res?.data.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.message);
  }
});

export const updateCategory = createAsyncThunk("category/updateCategory", async (categoryData, thunkAPI) => {
  try {
    const res = await categoryApi.update(categoryData.id, categoryData);

    return res?.data.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.message);
  }
});

const categorySlice = createSlice({
  name: "category",
  initialState: {
    categories: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllCategories.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.categories = action.payload;
      })
      .addCase(fetchAllCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateCategory.pending, (state, action) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createCategory.pending, (state, action) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createCategory.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateCategory.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.categories.findIndex(cat => cat.id === action.payload.id);
        if (index !== -1) {
          state.categories[index] = action.payload;
        }
      })
      .addCase(updateCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteCategory.pending, (state, action) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteCategory.fulfilled, (state, action) => {
        state.loading = false;
      //  state.categories = state.categories.filter(cat => cat.id !== action.meta.arg);
      })
      .addCase(deleteCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default categorySlice.reducer;
